// Progressive enhancement: without JS, the exact product/variant links remain usable.
export function resolveSelection(rows, wanted, changedIndex = -1, changedValue = '') {
  const values = [...wanted];
  if (changedIndex >= 0) values[changedIndex] = changedValue;
  const choices = [];
  for (let i = 0; i < values.length; i++) {
    const candidates = rows.filter(r => r.values.slice(0, i).every((v, j) => v === values[j]));
    choices[i] = [...new Set(candidates.map(r => r.values[i]))];
    if (!choices[i].includes(values[i])) values[i] = choices[i][0];
  }
  return { values, choices, row: rows.find(r => r.values.every((v, i) => v === values[i])) };
}
class LtCatalogFamily extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    try { this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent); }
    catch { return; }
    this.current = this.data.rows.find(r => String(r.id) === this.dataset.variant)
      || this.data.rows.find(r => r.handle === this.dataset.handle);
    if (!this.current) return;
    this.values = [...this.current.values];
    this.ui = this.querySelector('.lt-catalog__ui');
    this.ui.replaceChildren();
    const fields = document.createElement('div'); fields.className = 'lt-catalog__fields';
    this.selects = this.data.labels.map((label, i) => {
      const wrap = document.createElement('label'); wrap.className = 'lt-catalog__field';
      const caption = document.createElement('span'); caption.textContent = label;
      const select = document.createElement('select'); select.setAttribute('aria-label', label);
      select.addEventListener('change', () => this.update(i, select.value), { signal: this.controller.signal });
      wrap.append(caption, select); fields.append(wrap); return select;
    });
    this.status = document.createElement('p'); this.status.className = 'lt-catalog__status';
    this.status.setAttribute('role', 'status'); this.status.setAttribute('aria-live', 'polite');
    this.link = document.createElement('a'); this.link.className = 'lt-catalog__open';
    this.link.textContent = 'Vezi configurația aleasă';
    const note = document.createElement('p'); note.className = 'lt-family__note'; note.textContent = this.data.note;
    this.ui.append(fields, this.status, this.link, note);
    this.update(); this.ui.hidden = false; this.querySelector('.lt-catalog__fallback').hidden = true;
    this.closest('.shopify-section')?.addEventListener('shopify:product:select', event => {
      if (event.target?.closest('product-card, quick-add-dialog')) return;
      const sequence = this.selectionSequence = (this.selectionSequence || 0) + 1;
      event.promise?.then(({ detail }) => {
        if (!this.isConnected || sequence !== this.selectionSequence) return;
        const updated = [...(detail?.html?.querySelectorAll('lt-catalog-family') || [])]
          .find(el => el.dataset.handle === this.dataset.handle);
        const current = this.data.rows.find(r => String(r.id) === updated?.dataset.variant);
        if (!current) return;
        this.current = current; this.dataset.variant = String(current.id);
        this.values = [...current.values]; this.update();
      }).catch(() => { /* Keep the last confirmed variant on an aborted network request. */ });
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  update(index = -1, value = '') {
    const before = [...this.values];
    const state = resolveSelection(this.data.rows, this.values, index, value);
    if (!state.row) return;
    this.values = state.values;
    this.selects.forEach((select, i) => {
      select.replaceChildren(...state.choices[i].map(value => {
        const option = document.createElement('option'); option.value = value; option.textContent = value;
        option.selected = value === state.values[i]; return option;
      }));
      select.disabled = state.choices[i].length === 1;
    });
    const adjusted = this.data.labels.filter((_, i) => i > index && index >= 0 && before[i] !== state.values[i]);
    const same = state.row.id === this.current.id;
    this.status.textContent = same ? 'Aceasta este varianta afișată pe pagină.'
      : `${adjusted.length ? 'Opțiuni ajustate la combinațiile existente: ' + adjusted.join(', ').toLocaleLowerCase('ro') + '. ' : ''}Selecție: ${state.values.join(' · ')}. Apasă mai jos pentru a deschide produsul ales.`;
    this.link.hidden = same;
    const url = new URL(`${this.dataset.root}products/${state.row.handle}`, location.origin);
    url.searchParams.set('variant', String(state.row.id));
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    this.link.href = url.href;
  }
}
if (!customElements.get('lt-catalog-family')) customElements.define('lt-catalog-family', LtCatalogFamily);
